import { get } from 'lodash';

export const errorFor = (form, field) => {
  const touched = get(form, ['touched', field], false);
  const error = get(form, ['errors', field], false);

  return touched ? error : '';
};
